var map = {
	"./bg-box-icon.svg": "bJIZ",
	"./bg-footer.svg": "eqq4",
	"./bg-header-gray-lg.svg": "CXEZ",
	"./bg-header-gray.svg": "LO/q",
	"./bg-header-lg.svg": "fB+E",
	"./bg-header.svg": "ucpq",
	"./bg-newsletter.svg": "YNhZ",
	"./bg-scrollbar-thumb.svg": "cWin",
	"./bg-section-check-for-new-extensions-before.svg": "Rjvq",
	"./bg-section-select-your-theme-after.svg": "dk6U",
	"./bg-section-select-your-theme-before.svg": "CNq4",
	"./bg-section-subscribe-newsletter-before.svg": "M2sa",
	"./bg-section-veello-theme-insights-after.svg": "WODX",
	"./bg-section-veello-theme-insights-before.svg": "mozO",
	"./bg-section-why-choose-us-after.svg": "Z1yC",
	"./bg-section-why-choose-us-before.svg": "brD0",
	"./bg-veelloman-left.svg": "peJM",
	"./bg-veelloman.svg": "wxBg",
	"./logo-isotope.svg": "4Vi0",
	"./logo-light.svg": "Ezgv",
	"./logo-payment-footer.svg": "6lXt",
	"./logo-payment-paypal.svg": "JGwq",
	"./logo-payment-stripe-card.svg": "eznZ",
	"./logo-signet.svg": "ncI0",
	"./logo-white.svg": "ngSo",
	"./logo.svg": "9xNQ",
	"./text-meet-veelloman.svg": "XKp2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "VzBW";